var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCartMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.8027344,13.1533203C42.2304688,12.4208984,41.3686523,12,40.4384766,12H9.7807007L8.5380859,7.0302734 C8.0927734,5.2460938,6.4970703,4,4.6577148,4H2v2h2.6577148C5.5771484,6,6.375,6.6230469,6.5976562,7.5146484 l7.3642578,29.4550781C14.4072266,38.7539062,16.0029297,40,17.8422852,40H36v-2H17.8422852 c-0.9194336,0-1.7172852-0.6230469-1.9399414-1.5146484L14.7808838,32h21.3768311 c1.8393555,0,3.4350586-1.2460938,3.8803711-3.0302734l3.3110352-13.2421875 C43.574707,14.8251953,43.3754883,13.8867188,42.8027344,13.1533203z M41.4086914,15.2431641l-3.3110352,13.2421875 C37.875,29.3769531,37.0771484,30,36.1577148,30H14.2808228l-0.3106079-1.2421875L10.2807617,14h30.1577148 c0.3100586,0,0.597168,0.140625,0.7880859,0.3847656S41.4838867,14.9414062,41.4086914,15.2431641z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 44,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 44,
    r: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartMedium);
export default __webpack_public_path__ + "static/media/shopping-cart--medium.193cf48a6cccc3de203159c22bc5462f.svg";
export { ForwardRef as ReactComponent };